// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2EqN4","header":"MergedInvoice_header__3yzud"};